<template>
  <div>
    <q-card>
      <q-card-section>
        <q-tabs
          v-model="tab"
          no-caps
        >
          <q-tab
            name="unitsAndApplicants"
            label="Units & Applicants"
            :alert="isMainFormValid ? false : 'primary'"
          >
          </q-tab>
          <q-tab
            name="weights"
            label="Weights"
            :alert="isWeightsFormValid ? false : 'primary'"
          />
          <q-tab
            name="other"
            label="Other"
            :alert="isOtherFormValid ? false : 'primary'"
          />
        </q-tabs>
        <q-separator />
        <q-tab-panels
          ref="tabs"
          v-model="tab"
          animated
          keep-alive
        >
          <q-tab-panel name="unitsAndApplicants">

            <q-form
              ref="mainForm"
              @submit="onSubmit"
              greedy
            >
              <q-select
                v-model="selectedApplicantsGroup"
                label="Applicants groups"
                :options="applicantsGroups"
                style="width: auto"
                @update:model-value="updateGroupSelected"
              />
              <q-select
                v-model="selectedApplicants"
                multiple
                use-input
                :options="applicantsOptions"
                @filter="applicantsFilter"
                :option-label="item => item.firstName + ' ' + item.lastName"
                option-value="applicationId"
                label="Applicants"
                style="width: auto"
                use-chips
                map-options
                emit-value
                :rules="[(val) => val.length !== 0 || 'Please select values.']"
              >
                <template v-slot:option="{ itemProps, opt, selected, toggleOption }">
                  <q-item v-bind="itemProps">
                    <q-item-section>
                      <q-item-label v-html="opt.firstName + ' ' + opt.lastName" />
                    </q-item-section>
                    <q-item-section side>
                      <q-toggle
                        :model-value="selected"
                        @update:model-value="toggleOption(opt)"
                      />
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
              <q-separator />
              <div style="margin-top: 20px; font-size: 18px">Select units</div>
              <q-tree
                class="col-12 col-sm-6"
                :nodes="complexTree"
                node-key="key"
                tick-strategy="leaf"
                v-model:ticked="ticked"
                v-model:expanded="expanded"
                no-nodes-label="No complexes added, please add complex under complexes tab."
              />

            </q-form>
          </q-tab-panel>
          <q-tab-panel name="weights">
            <q-form
              ref="weightsForm"
              @submit="onSubmit"
              greedy
            >
              <div class="text-h6">Weights</div>
              <q-input
                v-model="algorithmWeights.sameSchoolYear"
                label="Same school year"
                style="width: 300px"
                :rules="[checkInputAndNonNegative]"
              />
              <q-input
                v-model="algorithmWeights.preferredRommatesDigiPenEmails"
                label="Rommates DigiPen emails"
                style="width: 300px"
                :rules="[checkInputAndNonNegative]"
              />
              <q-input
                v-model="algorithmWeights.preferredRoommateGenders"
                label="Roommate genders"
                style="width: 300px"
                :rules="[checkInputAndNonNegative]"
              />
              <q-input
                v-model="algorithmWeights.preferRoommateClean"
                label="Roommate clean"
                style="width: 300px"
                :rules="[checkInputAndNonNegative]"
              />
              <q-input
                v-model="algorithmWeights.preferRoommateSocial"
                label="Roommate social"
                style="width: 300px"
                :rules="[checkInputAndNonNegative]"
              />
              <q-input
                v-model="algorithmWeights.preferRoommateSharing"
                label="Rommates sharing"
                style="width: 300px"
                :rules="[checkInputAndNonNegative]"
              />
              <q-input
                v-model="algorithmWeights.preferRoommateSameDegree"
                label="Roommate same degree"
                style="width: 300px"
                :rules="[checkInputAndNonNegative]"
              />
              <q-input
                v-model="algorithmWeights.preferRoommateMorningPerson"
                label="Roommate morning person"
                style="width: 300px"
                :rules="[checkInputAndNonNegative]"
              />
              <q-input
                v-model="algorithmWeights.preferRoommateNightPerson"
                label="Roommate night person"
                style="width: 300px"
                :rules="[checkInputAndNonNegative]"
              />
              <q-input
                v-model="algorithmWeights.preferredApartmentRoomRateTable1"
                label="Rommates apartment preference 1"
                style="width: 300px"
                :rules="[checkInputAndNonNegative]"
              />
              <q-input
                v-model="algorithmWeights.preferredApartmentRoomRateTable2"
                label="Rommates apartment preference 2"
                style="width: 300px"
                :rules="[checkInputAndNonNegative]"
              />
              <q-input
                v-model="algorithmWeights.preferBuyOut1"
                label="Buyout as first preference"
                style="width: 300px"
                :rules="[checkInputAndNonNegative]"
              />
              <q-input
                v-model="algorithmWeights.preferBuyOut2"
                label="Buyout as second preference"
                style="width: 300px"
                :rules="[checkInputAndNonNegative]"
              />
            </q-form>
          </q-tab-panel>
          <q-tab-panel name="other">
            <q-form
              ref="otherForm"
              @submit="onSubmit"
              greedy
            >
              <div class="text-h6">Other options</div>
              <q-select
                v-model="buyoutRoomRates"
                multiple
                :options="sessionRoomRateTables"
                label="Buyout Roomrate Tables"
                style="width: auto"
                use-chips
                map-options
                emit-value
                :rules="[(val) => val.length > 0 || 'Please select at least one value.']"
              >
                <template v-slot:option="{ itemProps, opt, selected, toggleOption }">
                  <q-item v-bind="itemProps">
                    <q-item-section>
                      <q-item-label v-html="opt" />
                    </q-item-section>
                    <q-item-section side>
                      <q-toggle
                        :model-value="selected"
                        @update:model-value="toggleOption(opt)"
                      />
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
              <q-select
                v-model="raRoomRate"
                :options="roomRateTables"
                label="RA Roomrate"
                style="width: auto"
              />
              <q-input
                v-model="iterationCount"
                label="Iteration Count"
                :rules="[(val) => val > 0 || 'Please input value above 0.']"
              />
              <!-- <q-input
                v-model="repeatCount"
                label="Repeat Run Count"
                :rules="[(val) => val > 0 || 'Please input value above 0.']"
              /> -->
            </q-form>
          </q-tab-panel>
        </q-tab-panels>
        <div
          class="row items-center"
          style="margin-top: 20px"
        >
          <q-avatar
            icon="info"
            size="md"
            color="primary"
            text-color="white"
          />
          <span class="q-ml-sm">
            All unplaced and unlocked students will be part of the placement algo.
            <br />
            Manually assigned students, unless locked or placed, will be 'reshuffled'.
          </span>
        </div>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn
          flat
          label="Cancel"
          v-close-popup
        />
        <q-btn
          flat
          color="primary"
          label="Confirm"
          @click="onSubmit"
        />
      </q-card-actions>
    </q-card>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  onMounted,
} from 'vue';
import useAlgorithmOptions from '@/hooks/algorithmOptions';
import useComplexTree from '@/hooks/complexTree';
import usePlacement from '@/hooks/placement';
import useSession from '@/hooks/session';
import useUiUtilities from '@/utilities/uiUtilities';
import useUtility from '@/hooks/utility';

const props = defineProps({
  sessionId: Number,
});

const emit = defineEmits([{
  confirm: null,
}]);

const tab = ref('unitsAndApplicants');
const tabNames = ref(['unitsAndApplicants', 'weights', 'other']);
const tabs = ref(null);
const selectedApplicantsGroup = ref(null);
const selectedApplicants = ref([]);
const {
  applicantsGroups,
  applicantsInSession,
  algorithmWeights,
  buyoutRoomRates,
  getApplicantsInSession,
  iterationCount,
  lockedPlacedOrBlockedApplicants,
  lockedPlacedBlockedOrTentativeApplicants,
  raRoomRate,
} = useAlgorithmOptions();
const {
  fetchComplexTree, complexTree, ticked, expanded, resetTicks,
} = useComplexTree();
const { getRoomRateTablesBySession } = useSession();
const { notifyResult } = useUiUtilities();
const {
  getRoomRateTables,
  roomRateTables,
} = useUtility();
const { runAlgo } = usePlacement();
const sessionRoomRateTables = ref([]);
const mainForm = ref(null);
const otherForm = ref(null);
const weightsForm = ref(null);
const isMainFormValid = ref(true);
const isOtherFormValid = ref(true);
const isWeightsFormValid = ref(true);

onMounted(async () => {
  // load tabs by traversing each : https://codepen.io/metalsadman/pen/povXyrL
  const traversal = tabNames.value.reduce((promiseChain, item) => promiseChain.then(
    () => new Promise((resolve) => {
      resolve();
      tabs.value.goTo(item);
    }),
  ), Promise.resolve());
  await traversal;
  tabs.value.goTo('unitsAndApplicants');
});

const confirmRunAlgo = async () => {
  const unitIds = ticked.value.filter((x) => x.startsWith('Unit')).map((x) => x.substring(x.indexOf(':') + 1));
  const algorithmOptions = {
    weights: algorithmWeights.value,
    buyoutRoomRates: buyoutRoomRates.value.filter((x) => x !== 'No buyout for this session'),
    iterationCount: iterationCount.value,
    raRoomRate: raRoomRate.value === 'No RA rate' ? null : raRoomRate.value,
  };
  const selectedApplicantIds = selectedApplicants.value.concat(
    lockedPlacedOrBlockedApplicants.value.map((x) => x.applicationId),
  );

  const response = await runAlgo(
    props.sessionId, selectedApplicantIds, unitIds, algorithmOptions,
  );
  return response;
};

const onSubmit = async () => {
  isMainFormValid.value = await mainForm.value.validate();
  isWeightsFormValid.value = await weightsForm.value.validate();
  isOtherFormValid.value = await otherForm.value.validate();
  if (isMainFormValid.value && isWeightsFormValid.value && isOtherFormValid.value) {
    const response = await confirmRunAlgo();
    notifyResult(response.status);
    if (response.status === 200 || response.status === 201) {
      emit('confirm');
    }
  }
};

sessionRoomRateTables.value = await getRoomRateTablesBySession(props.sessionId);

resetTicks();
await fetchComplexTree(props.sessionId);
await getApplicantsInSession(props.sessionId);
await getApplicantsInSession(props.sessionId, true);
await getApplicantsInSession(props.sessionId, true, true);
await getRoomRateTables();
roomRateTables.value.unshift('No RA rate');

const applicantsInSessionList = applicantsInSession;
const applicantsOptions = ref(applicantsInSessionList.value);

const allApplicantEmailssSet = new Set(applicantsInSession.value.map(
  (x) => x.digipenEmail.toLowerCase(),
));

const addRoommatesHelper = (applicants) => {
  const applicantsToAdd = new Set();
  const applicantIds = new Set();
  for (let i = 0; i < applicants.length; i += 1) {
    const perfRoommates = [
      applicants[i].preferredRoommateDigipenEmail1,
      applicants[i].preferredRoommateDigipenEmail2,
      applicants[i].preferredRoommateDigipenEmail3,
      applicants[i].preferredRoommateDigipenEmail4,
    ].filter((x) => x != null);

    perfRoommates.forEach((roommate) => {
      if (allApplicantEmailssSet.has(roommate.toLowerCase())) {
        const item = applicantsInSession.value.filter(
          (x) => x.digipenEmail.toLowerCase() === roommate.toLowerCase(),
        )[0];
        if (item) {
          applicantsToAdd.add(item);
          applicantIds.add(item.applicationId);
        }
      }
    });
  }

  return [applicantsToAdd, applicantIds];
};

const removeApplicantsSecondListFromFirstList = (listOne, listTwo) => {
  const result = Array.from(listOne);
  listTwo.forEach((x) => {
    result.forEach((y) => {
      if (y.applicationId === x.applicationId) {
        result.splice(result.indexOf(y), 1);
      }
    });
  });

  return result;
};

const addRoommatesOfApplicants = () => {
  const [applicantsRoommates] = addRoommatesHelper(applicantsOptions.value);
  const [roommatesRoommates, roommatesRoomateIds] = addRoommatesHelper([...applicantsRoommates]);

  const duplicateRoommates = new Set();

  applicantsRoommates.forEach((x) => {
    if (roommatesRoomateIds.has(x.applicationId)) {
      roommatesRoomateIds.delete(x.applicationId);
    }
  });
  roommatesRoommates.forEach((x) => {
    if (!roommatesRoomateIds.has(x.applicationId)) {
      duplicateRoommates.add(x);
    }
  });
  applicantsOptions.value.forEach((x) => {
    if (!roommatesRoomateIds.has(x.applicationId)) {
      duplicateRoommates.add(x);
    }
  });
  duplicateRoommates.forEach((x) => {
    roommatesRoommates.delete(x);
  });

  const tempSet = new Set(
    [...applicantsOptions.value, ...applicantsRoommates, ...roommatesRoommates],
  );
  applicantsOptions.value = [...tempSet];
  // applicantsOptions.value = removeApplicantsSecondListFromFirstList(applicantsOptions.value);

  applicantsOptions.value.sort((a, b) => {
    if (a.firstName > b.firstName) return 1;
    if (a.firstName < b.firstName) return -1;
    return 0;
  });
};

const filterApplicantsByGroup = () => {
  if (selectedApplicantsGroup.value === 'Freshmen') {
    applicantsOptions.value = applicantsInSessionList.value.filter(
      (x) => x.academicYear === 'Freshman',
    );
  } else if (selectedApplicantsGroup.value === 'EAP') {
    applicantsOptions.value = applicantsInSessionList.value.filter(
      (x) => x.hasAppliedToEap,
    );
  } else if (selectedApplicantsGroup.value === 'Upperclassmen') {
    applicantsOptions.value = applicantsInSessionList.value.filter(
      (x) => x.academicYear === 'Sophomore'
        || x.academicYear === 'Junior'
        || x.academicYear === 'Senior'
        || x.academicYear === 'Graduate Level',
    );
  } else if (selectedApplicantsGroup.value === 'Freshmen & Preferred Roommates') {
    applicantsOptions.value = applicantsInSessionList.value.filter(
      (x) => x.academicYear === 'Freshman',
    );
    addRoommatesOfApplicants();
  } else if (selectedApplicantsGroup.value === 'EAP & Preferred Roommates') {
    applicantsOptions.value = applicantsInSessionList.value.filter(
      (x) => x.hasAppliedToEap,
    );
    addRoommatesOfApplicants();
  } else if (selectedApplicantsGroup.value === 'Returning to Housing') {
    applicantsOptions.value = applicantsInSessionList.value.filter(
      (x) => x.isReturningToHousing,
    );
  } else if (selectedApplicantsGroup.value === 'Returning to Housing & Preferred Roommates') {
    applicantsOptions.value = applicantsInSessionList.value.filter(
      (x) => x.isReturningToHousing,
    );
    addRoommatesOfApplicants();
  } else if (selectedApplicantsGroup.value === 'Not Locked, Placed, Blocked, or Tentative') {
    applicantsOptions.value = removeApplicantsSecondListFromFirstList(
      applicantsInSessionList.value, lockedPlacedBlockedOrTentativeApplicants.value,
    );
  } else {
    applicantsOptions.value = removeApplicantsSecondListFromFirstList(
      applicantsInSessionList.value, lockedPlacedOrBlockedApplicants.value,
    );
  }
};

const applicantsFilter = (val, update) => {
  update(() => {
    filterApplicantsByGroup();
    if (val !== '') {
      const needle = val.toLowerCase();
      applicantsOptions.value = applicantsInSessionList.value.filter(
        (v) => `${v.firstName.toLowerCase()} ${v.lastName.toLowerCase()}`.indexOf(needle) > -1,
      );
    }
  });
};

const updateGroupSelected = () => {
  filterApplicantsByGroup();
  selectedApplicants.value = applicantsOptions.value.map((x) => x.applicationId);
};

const checkInputAndNonNegative = (val) => (!!val && val >= 0) || 'Please input value 0 or above.';
</script>
